import { render } from "./vgooutreceivemonad.vue?vue&type=template&id=bd95f3e0&scoped=true"
import script from "./vgooutreceivemonad.vue?vue&type=script&lang=js"
export * from "./vgooutreceivemonad.vue?vue&type=script&lang=js"

import "./vgooutreceivemonad.vue?vue&type=style&index=0&id=bd95f3e0&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd95f3e0"]])

export default __exports__